





































import {defineComponent, PropType} from '@vue/composition-api';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import TableInput from '@/tasks/components/inputs/TableInput.vue';
import STextareaShort from '@/common/components/STextareaShort.vue';
import StembleLatex from '@/tasks/components/StembleLatex.vue';

export default defineComponent({
  name: 'UCIrvineELN1v2Observations3',
  components: {StembleLatex, TableInput},
  mixins: [DynamicQuestionMixin()],
  props: {
    isMarking: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      inputs: {
        glasswareMass: '',
        molarMass: '',
        vSoln: '',
        massTableRows: [
          {glasswareType: '', sucroseMass: '', solutionMass: '', sucroseMol: '', dSoln: ''},
        ],
      },
      massColumns: [
        {label: 'Glassware Type', component: STextareaShort, prop: 'glasswareType', width: '10%'},
        {label: 'Sucrose Mass (g)', component: STextareaShort, prop: 'sucroseMass', width: '20%'},
        {
          label: 'Solution Mass m(2) (g)',
          component: STextareaShort,
          prop: 'solutionMass',
          width: '25%',
        },
        {label: '[Sucrose] (M)', component: STextareaShort, prop: 'sucroseMol', width: '20%'},
        {label: 'd(soln) (g/mL)', component: STextareaShort, prop: 'dSoln', width: '25%'},
      ],
      questions: [
        {
          text: 'Glassware Mass (m1) (g)',
          inputName: 'glasswareMass',
        },
        {
          text: 'Molar Mass (sucrose) (g/mol):',
          inputName: 'molarMass',
        },
        {
          text: 'Vsoln (mL):',
          inputName: 'vSoln',
        },
      ],
    };
  },
  methods: {},
});
